(function () {
  function initStickyProductImages() {
    var stickyEl = document.querySelector('.product-single__sticky');
    if (!stickyEl) return;

    var MEDIA_QUERY = window.matchMedia('(min-width: 769px)');

    var TOP_OFFSET_DEFAULT = 20;
    var TOP_OFFSET_STICKY_HEADER = 140;
    var BOTTOM_OFFSET = 20;

    var lastScrollY = window.scrollY;
    var direction = 'down';
    var ticking = false;

    // 上スクロール時の現在位置
    var smartTop = null;

    function getTopOffset() {
      return document.body.classList.contains('sticky-header')
        ? TOP_OFFSET_STICKY_HEADER
        : TOP_OFFSET_DEFAULT;
    }

    function update() {
      ticking = false;

      if (!MEDIA_QUERY.matches) {
        stickyEl.style.position = '';
        stickyEl.style.top = '';
        return;
      }

      var currentScrollY = window.scrollY;
      var scrollDiff = currentScrollY - lastScrollY;

      // スクロール方向を判定
      if (scrollDiff > 0) {
        direction = 'down';
      } else if (scrollDiff < 0) {
        direction = 'up';
      }

      var stickyHeight = stickyEl.offsetHeight;
      var topOffset = getTopOffset();

      /*
       * 現在の画面上での位置
       */
      var rect = stickyEl.getBoundingClientRect();

      /*
       * 下スクロール
       * → 画面下20pxに固定
       */
      if (direction === 'down') {

        stickyEl.style.position = 'sticky';

        stickyEl.style.top =
          'calc(100vh - ' +
          BOTTOM_OFFSET +
          'px - ' +
          stickyHeight +
          'px)';

        // 上スクロール用の位置をリセット
        smartTop = null;

      } else if (direction === 'up') {

        /*
         * 上スクロールに切り替わった瞬間
         *
         * いきなりtop:140pxにせず、
         * 現在表示されている位置からスタートする
         */
        if (smartTop === null) {
          smartTop = rect.top;
        } else {
          /*
           * スクロールした分だけ上へ移動
           */
          smartTop += scrollDiff;
        }

        /*
         * ヘッダー位置より上には行かない
         */
        if (smartTop < topOffset) {
          smartTop = topOffset;
        }

        stickyEl.style.position = 'sticky';
        stickyEl.style.top = smartTop + 'px';
      }

      lastScrollY = currentScrollY;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    function onResize() {
      smartTop = null;
      lastScrollY = window.scrollY;

      stickyEl.style.position = '';
      stickyEl.style.top = '';

      onScroll();
    }

    window.addEventListener('scroll', onScroll, {
      passive: true
    });

    window.addEventListener('resize', onResize);

    window.addEventListener('load', onScroll);

    if (MEDIA_QUERY.addEventListener) {
      MEDIA_QUERY.addEventListener('change', onResize);
    } else {
      MEDIA_QUERY.addListener(onResize);
    }

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initStickyProductImages
    );
  } else {
    initStickyProductImages();
  }
})();